import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M6 5a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 00-1-1H6zm3.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-2.022 4.735l1.598-2.557a.5.5 0 01.848 0l1.305 2.088 2.09-3.537a.5.5 0 01.861 0l2.374 4.017a.5.5 0 01-.43.754h-4.748a.508.508 0 01-.139-.02.508.508 0 01-.14.02H7.903a.5.5 0 01-.424-.765z",
      "clip-rule": "evenodd"
    })
  ]))
}